import React, { useState } from "react";

function Image({ src, className }) {

    const [loadingStatus, setLoadingStatus] = useState(null);

    const loaded = loadingStatus === "loaded";
    const failed = loadingStatus === "failed";

    // TODO: improve alt text
    return (
    <>
        {src && !failed &&
            // If image is loading, show "loading skeleton"
            // Once it finished loading, show image
            <>
                <div 
                    className={`rounded-md bg-gray-200 animate-pulse ${className} ${loaded ? "hidden" : "block"}`} 
                    aria-hidden="true" 
                    role="presentation"
                >
                </div>
                <img 
                    src={src} 
                    alt="Podcast cover"
                    className={`rounded-md ${className} ${loaded ? "block" : "hidden"}`}
                    onLoad={() => setLoadingStatus("loaded")}
                    onError={() => setLoadingStatus("failed")}
                />
            </>
        }
        {(!src || failed) &&
            // If there's no image source or loading failed
            // show "not found"
            <div 
                className={`rounded-md bg-gray-200 uppercase text-gray-500 text-sm grid place-content-center text-center ${className}`}
                aria-hidden="true" 
                role="presentation"
            >
                Not found
            </div>
        }
    </>
    )
}

export default Image;